var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm.question ? _c('div', {
    staticClass: "w-full max-w-lg flex flex-col"
  }, [_vm.header ? _c('h1', [_vm._v(_vm._s(_vm.header)), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.question.title))]), _vm._v(" "), _vm.question.description ? _c('p', {
    staticClass: "mt-2 whitespace-pre-line text-lg text-gray-500"
  }, [_vm._v(_vm._s(_vm.question.description))]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "flex flex-col mt-4 gap-4",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return (() => _vm.submit()).apply(null, arguments);
      }
    }
  }, [_vm._l(_vm.question.choices, function (choice) {
    return _c('div', {
      key: choice.id,
      staticClass: "question"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('input', {
      staticClass: "!mt-0",
      attrs: {
        "id": `member-survey-${choice.id}`,
        "type": _vm.question.multiselect ? 'checkbox' : 'radio'
      },
      domProps: {
        "checked": Boolean(_vm.selected[choice.id]),
        "value": choice.id
      },
      on: {
        "change": function ($event) {
          return _vm.setResponse(choice.id, $event.currentTarget.checked);
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "grow !text-lg !font-normal !text-gray-500",
      class: {
        'pl-6': _vm.question.multiselect
      },
      attrs: {
        "for": `member-survey-${choice.id}`
      }
    }, [_vm._v(_vm._s(choice.title))])]), _vm._v(" "), choice.freeform && _vm.selected[choice.id] ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.freeformResponses[choice.id],
        expression: "freeformResponses[choice.id]"
      }],
      staticClass: "text-left text-lg placeholder:text-gray-700 border-gray-700",
      attrs: {
        "type": "text",
        "placeholder": choice.placeholder,
        "maxlength": "256"
      },
      domProps: {
        "value": _vm.freeformResponses[choice.id]
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.freeformResponses, choice.id, $event.target.value);
        }
      }
    })]) : _vm._e()]);
  }), _vm._v(" "), _vm._t("additionalDisclaimers"), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col gap-4 bottom"
  }, [_vm.isCreditGoalsFirstQuestion ? _c('p', {
    staticClass: "mt-4 leading-6 text-[#a5a5a5]"
  }, [_c('span', [_vm._v("\n\t\t\t\t\tBy clicking “Continue”, I acknowledge that I have read the\n\t\t\t\t\t"), _c('a', {
    staticClass: "underline",
    attrs: {
      "href": "",
      "target": "_blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.disclosureOpen = true;
      }
    }
  }, [_vm._v("Matches by Extra™ Terms of Use")]), _vm._v("\n\t\t\t\t\tand agree to its terms; and I give Extra permission to provide me with relevant offers\n\t\t\t\t\tthat match my credit goals.\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button--filled mt-4",
    attrs: {
      "type": "submit",
      "disabled": _vm.submitDisabled
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.processing ? 'Loading...' : 'Continue') + "\n\t\t\t")])])], 2), _vm._v(" "), _c('modal-overlay', {
    attrs: {
      "open": _vm.disclosureOpen,
      "blur": false,
      "z-index": 900
    }
  }, [_c('div', {
    staticClass: "w-screen h-screen bg-black"
  }, [_c('div', {
    staticClass: "section--container h-full sm-md:!pt-8 !pb-0"
  }, [_c('div', {
    staticClass: "container max-w-lg section--content h-full pt-8 sm-md:pt-0 relative"
  }, [_c('h1', [_vm._v("Terms of Use")]), _vm._v(" "), _c('p', {
    staticClass: "mt-4 text-lg leading-6 font-light"
  }, [_vm._v("\n\t\t\t\t\t\tBy clicking “Continue”, I acknowledge and agree to Extra’s Terms of Service and\n\t\t\t\t\t\tPrivacy Policy. I authorize Extra and its affiliates to use any self-reported\n\t\t\t\t\t\tinformation I provide (such as, my credit goals and my self-reported credit score), or\n\t\t\t\t\t\tany other information I may expressly authorize Extra to use, to determine which\n\t\t\t\t\t\tcredit card offers, personal loan offers, and/or mortgage lender introductions may be\n\t\t\t\t\t\tavailable to me based on criteria (including credit criteria) made available to Extra\n\t\t\t\t\t\tby participating lenders or credit card issuers. I understand that there is no\n\t\t\t\t\t\tguarantee that an offer may be available for me. I acknowledge that even if I receive\n\t\t\t\t\t\tan indication or inference that I am likely to be qualified or approved for a\n\t\t\t\t\t\tparticular offer and I apply for that offer, there is no guarantee that I will be\n\t\t\t\t\t\tapproved by the lender or credit card issuer or that a loan will be made or a card\n\t\t\t\t\t\tissued to me. I understand that, by participating in Matches by Extra™ or by clicking\n\t\t\t\t\t\t“Learn More” on a particular match, I am not submitting an application for credit; and\n\t\t\t\t\t\tthat, if I wish to apply for a credit card or loan with a particular credit card\n\t\t\t\t\t\tissuer or lender, I will need to submit an application directly with that issuer or\n\t\t\t\t\t\tlender. I understand that Extra will not be able to tell me why I did or did not\n\t\t\t\t\t\tqualify for any particular financial offering.\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button--filled my-8 w-full",
    on: {
      "click": function ($event) {
        _vm.disclosureOpen = false;
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tContinue\n\t\t\t\t\t")])])])])])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };